import {assign} from 'min-dash';
import type {ModdleConfig, ModdlePackage} from 'moddle';

import ArchimateModdle from './Moddle';
import ArchimateDescriptors from './resources/archimate.json';

const packages = {
	archimate: ArchimateDescriptors as ModdlePackage,
};

export default class ExtendedArchimateModdle extends ArchimateModdle {
	constructor(additionalPackages?: Record<string, ModdlePackage>, options?: ModdleConfig) {
		const pks = assign({}, packages, additionalPackages);
		super(pks, options);
	}
}
